import { TextField, Button, Container, Typography, Box, InputAdornment, IconButton } from '@mui/material';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Visibility from '@mui/icons-material/Visibility';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import React, { useState } from 'react';

export default function LogIn() {
  const [showPassword, setShowPassword] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState('');
  const [loading, setLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleUsernameChange = (e) => {
    const value = e.target.value;
    setUsername(value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      username: value ? "" : "Enter Username"
    }))
  }

  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPassword(value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      password: value ? "" : "Enter Password"
    }))
  }

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) {
      return;
    }

    if (!username || !password) {
      setErrors((prevErrors) => ({
          ...prevErrors,
          username: !username ? 'Username is required' : prevErrors.username,
          password: !password ? "Password is required" : prevErrors.password,
      }));

      setIsSubmitting(false);
      return;
    } 

    setIsSubmitting(true);

    setLoading(true);
    try {
      const response = await fetch(`/api/MyLogIn`, {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password }),
      });
      if (response.ok) {
        localStorage.setItem("isLoggedIn", "true");        
        navigate('/Dashboard');
        window.location.reload();
      } else {
        const data = await response.json();
        toast.error(data.error);
      }
    } catch (error) {
      console.error('Error during login:', error);
    } finally {
      setLoading(false);
    }
    setIsSubmitting(false);
  };

  return (
    <>
      <Box sx={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#f8f9fa'}}>
        <Container maxWidth="sm">
          <Box className="shadow p-4 rounded" sx={{ backgroundColor: 'white', padding: 4 }}>
            <Typography variant="h4" className="text-center mb-4 archieve">Login To <span className="scholarVarsity">Fatehpur Public School</span></Typography>
              <Box className="mb-3">
                <TextField label="Username" variant="outlined" fullWidth value={username} autoComplete="current-username" onChange={handleUsernameChange}
                  error={!!errors.username} helperText={!!errors.username} />
              </Box>
              <Box className="mb-3">
                <TextField label="Password" type={showPassword ? 'text' : 'password'} variant="outlined" fullWidth value={password} autoComplete="current-password" onChange={handlePasswordChange} InputProps={{ endAdornment: (<InputAdornment position="end"> <IconButton onClick={togglePasswordVisibility}>{showPassword ? <VisibilityOff /> : <Visibility />}</IconButton> </InputAdornment>) }} error={!!errors.password} helperText={!!errors.password} />
              </Box>
              <Box className="text-center">
                <Button type="submit" variant="contained" color="primary" size="large" onClick={handleSubmit}>Login</Button>
              </Box>
          </Box>
        </Container>
      </Box>
      {loading && (
        <div className="modal-backdrop show"></div>
      )}
      <div className={`modal fade ${loading ? 'show' : ''}`} style={{ display: loading ? 'block' : 'none' }} tabIndex="-1" role="dialog">
        <div id="preloader">
          <div className="bar-container">
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
          </div>
          <h1>Loading...</h1>
        </div>
      </div>
      <ToastContainer />
    </>
  );
}
